"use strict";

var _interopRequireDefault = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.error.cause.js");
var _regeneratorRuntime2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/createClass.js"));
var _assertThisInitialized2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/assertThisInitialized.js"));
var _inherits2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/inherits.js"));
var _createSuper2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/createSuper.js"));
var _defineProperty2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _auth = require("@/api/auth");
var _validate = require("@/utils/validate");
var _vuePropertyDecorator = require("vue-property-decorator");
var _OTPForm = _interopRequireDefault(require("./OTPForm.vue"));
var ForgotForm = /*#__PURE__*/function (_Vue) {
  (0, _inherits2.default)(ForgotForm, _Vue);
  var _super = (0, _createSuper2.default)(ForgotForm);
  function ForgotForm() {
    var _this;
    (0, _classCallCheck2.default)(this, ForgotForm);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "form", {});
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "loading", false);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "rules", {
      email: {
        required: true,
        trigger: "sumbit",
        validator: _this.validateEmail
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "isSentEmail", false);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "$refs", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "visibleOTP", false);
    return _this;
  }
  (0, _createClass2.default)(ForgotForm, [{
    key: "validateEmail",
    value: function validateEmail(rule, value, callback) {
      if (!(0, _validate.validEmail)(value)) {
        return callback(new Error("Email is invalid"));
      }
      callback();
    }
  }, {
    key: "handleSubmit",
    value: function () {
      var _handleSubmit = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.$refs.form.validate();
              case 2:
                this.loading = true;
                _context.prev = 3;
                _context.next = 6;
                return _auth.authApi.forgot(this.form);
              case 6:
                res = _context.sent;
                this.$notify.success({
                  title: "Forgot password",
                  message: "A code sent to your email"
                });
                // this.visibleOTP = true;
                this.isSentEmail = true;
              case 9:
                _context.prev = 9;
                this.loading = false;
                return _context.finish(9);
              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[3,, 9, 12]]);
      }));
      function handleSubmit() {
        return _handleSubmit.apply(this, arguments);
      }
      return handleSubmit;
    }()
  }]);
  return ForgotForm;
}(_vuePropertyDecorator.Vue);
ForgotForm = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    OTPForm: _OTPForm.default
  }
})], ForgotForm);
var _default = ForgotForm;
exports.default = _default;